import * as React from 'react';
import numbro from 'numbro';

const loadModules = async (locales: string[]) => {
  const modules = locales.map(locale =>
    import(`numbro/dist/languages/${locale}.min.js`)
      .then(lang => {
        numbro.registerLanguage(lang.default);
      })
      .catch(() => console.error(`Invalid locale provided: "${locale}" - will render as default en-US.`)),
  );

  await Promise.all(modules);
};

export const useSpreadsheetCurrencyLocales = (locales: string[] = []) => {
  /* en-US is always loaded by default, so we can exclude it if it ends up here */
  const filteredLocales = locales.filter(locale => locale !== 'en-US');

  /* If no other locales are provided, we can skip loading */
  const alreadyDone = filteredLocales.length === 0;
  const [done, setDone] = React.useState(alreadyDone);

  React.useEffect(() => {
    if (done) {
      return;
    }

    loadModules(filteredLocales).then(() => setDone(true));
  }, [filteredLocales, done]);

  return done;
};
